import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('memberStates', app)
  return store
}
